import moment from "moment";

// Keys are the exact backend PaymentStatus enum values (clients/models/contract.py).
export const PAYMENT_STATUS = {
  OVERDUE: "OVERDUE",
  DUE_SOON: "DUE_SOON",
  SCHEDULED: "SCHEDULED",
  UNSCHEDULED: "UNSCHEDULED",
  SETTLED: "SETTLED",
};

export const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "Any payment state" },
  { value: PAYMENT_STATUS.OVERDUE, label: "Overdue" },
  { value: PAYMENT_STATUS.DUE_SOON, label: "Due in 30 days" },
  { value: PAYMENT_STATUS.SCHEDULED, label: "Scheduled" },
  { value: PAYMENT_STATUS.UNSCHEDULED, label: "Unscheduled" },
  { value: PAYMENT_STATUS.SETTLED, label: "Fully settled" },
];

/**
 * Pure mapping from a contract's payment_status + next_payment (as returned
 * by ContractSerializer) to what the "Next payment" cell should render:
 * dot color, label, amount meta text, and a text color class.
 */
export const getPaymentStatusMeta = (paymentStatus, nextPayment, formatCurrency) => {
  const amountText = nextPayment
    ? formatCurrency(nextPayment.amount, "EUR")
    : null;
  const dueText = nextPayment?.booking_date
    ? moment(nextPayment.booking_date).format("DD MMM YYYY")
    : null;

  switch (paymentStatus) {
    case PAYMENT_STATUS.OVERDUE:
      return {
        dotColor: "var(--vz-danger)",
        label: dueText ? `Overdue since ${dueText}` : "Overdue",
        amountText,
        textClass: "text-danger",
      };
    case PAYMENT_STATUS.DUE_SOON:
      return {
        dotColor: "var(--vz-warning)",
        label: dueText ? `Due ${dueText}` : "Due soon",
        amountText,
        textClass: "text-body",
      };
    case PAYMENT_STATUS.SCHEDULED:
      return {
        dotColor: "var(--vz-primary)",
        label: dueText ? `Due ${dueText}` : "Scheduled",
        amountText,
        textClass: "text-body",
      };
    case PAYMENT_STATUS.UNSCHEDULED:
      return {
        dotColor: "var(--vz-secondary)",
        label: "No due date",
        amountText: "needs scheduling",
        textClass: "text-muted",
      };
    case PAYMENT_STATUS.SETTLED:
    default:
      return {
        dotColor: "var(--vz-secondary)",
        label: "Fully settled",
        amountText: null,
        textClass: "text-muted",
      };
  }
};
